import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        return (
            <main>
                <div className="p-5 pb-md-4 mx-auto text-center">
                    <h2 className="display-4 fw-normal">
                        Program Assessment Reporting
                    </h2>
                    <p className="fs-5 text-muted">
                        Report program assessment efforts at the office, from home, or on the go.
                    </p>
                </div>
                
                <div className="row row-cols-1 row-cols-md-4 text-center">
                    <div className="col col-md"></div>
                    <div className="col col-md-6">
                        <div className="card mb-4 rounded-3 shadow-sm border-primary">
                            <div className="card-header py-3 text-bg-primary">
                                <h4 className="my-0 fw-normal">Version 2.0 - New</h4>
                            </div>
                            <div className="card-body">
                                <h3>Universal Themes Assessment</h3>
                                <p>
                                    Use this option to work through the new Universal Themes Assessment 
                                    process developed by the Assessment Academy team for program level 
                                    assessment of degrees, certificates, and gen ed areas.
                                </p>
                                <LinkContainer to="v2">
                                    <Button
                                        href="v2" 
                                        variant="primary" 
                                        className="w-100" 
                                        size="lg"
                                        >
                                        Go
                                    </Button>
                                </LinkContainer>
                            </div>
                        </div>
                    </div>
                    <div className="col col-md"></div>
                </div>
                <div className="p-5 pb-md-4 mx-auto text-center">
                    <span className="text-muted">
                        If you do not know which option to use, contact <a href="mailto:assessment@cnm.edu">assessment@cnm.edu</a> for assistance.
                    </span>
                </div>
            </main>
        )
    }
}

export default Home;